import { useMutation, useQueryClient } from "@tanstack/react-query";
import ordersClient, { OrderClock } from "../../../api/order";

const useUpdateOrderClocksMutation = (orderId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { clocks: OrderClock[]; clocksNumber?: number }) =>
      ordersClient.updateOrderClocks(orderId, input.clocks, input.clocksNumber),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["order", orderId] });
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};

export default useUpdateOrderClocksMutation;
